export default function Show(props) {
  const { condition, children } = props;
  if (condition) {
    return <>{children}</>;
  }
  return [];
}
